module.exports = __webpack_public_path__ + "img/kongzhigk.fe85f717.png";